import { Table } from '@tszhong0411/ui/components/table'
import { cn } from '@tszhong0411/utils'

type CommentTableProps = React.ComponentProps<'table'>

const CommentTable = (props: CommentTableProps) => {
  const { className, ...rest } = props

  return <Table className={cn('not-prose my-2', className)} {...rest} />
}

export default CommentTable
